type RemovedCharacter = {
  caractere: string;
  codigo: string;
  ocorrencias: number;
};

export function sanitizeUsername(value: string) {
  const prohibited = new Set(Array.from('<>&"\'$%!#?§,;:*~/\\|^=[]{}()`'));
  const removed = new Map<string, RemovedCharacter>();
  let username = "";

  for (const character of Array.from(value)) {
    const whitespace = /\p{White_Space}/u.test(character) || character === "\u180e";
    const control = /\p{Cc}/u.test(character);
    if (whitespace || control || prohibited.has(character)) {
      const code = `U+${character.codePointAt(0)!.toString(16).toUpperCase().padStart(4, "0")}`;
      const existing = removed.get(code);
      if (existing) {
        existing.ocorrencias++;
      } else {
        removed.set(code, {
          caractere: character === " " ? "ESPAÇO" : whitespace ? "ESPAÇO EM BRANCO" : control ? "CONTROLE" : character,
          codigo: code,
          ocorrencias: 1,
        });
      }
    } else {
      username += character;
    }
  }

  return { username, removed: Array.from(removed.values()) };
}
